import { last } from 'lodash';

const dict = {
  fees: 'Fees',
  overview: 'Overview',
  title: 'Title Summary',
};

// ActiveMain and ActiveSub are props for MiniNavigation and SubNavigation.
// Basically, they're the 'highlighted' links on the header.
export const determineActiveMainAndActiveSub = (pathname: string): { activeMain?: string; activeSub?: string } => {
  const pathElements = pathname.split('/');
  return {
    activeSub: dict[last(pathElements) || ''],
    activeMain: pathElements.includes('order') ? 'Orders' : undefined,
  };
};
